import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDarkerSpinner = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={32}
    fill="currentColor"
    viewBox="0 0 31 32"
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule="evenodd"
      d="M27.3 4.7C24.04 1.44 19.42-.44 14.34.08 7 .82.96 6.78.14 14.12-.96 23.82 6.54 32 16 32c6.38 0 11.86-3.74 14.42-9.12.64-1.34-.32-2.88-1.8-2.88-.74 0-1.44.4-1.76 1.06-2.26 4.86-7.68 7.94-13.6 6.62-4.44-.98-8.02-4.6-8.96-9.04C2.62 10.88 8.52 4 16 4c3.32 0 6.28 1.38 8.44 3.56 0 0 1.375 1.248 2.67.28 1.294-.967.19-3.14.19-3.14"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDarkerSpinner;
